ActivityMemberMenuView = require 'views/member-menu-profile/activity-member-menu-view'
CardActionsPopover = require './card-actions-popover'
Dates = require 'lib/dates'
Dialog = require 'views/lib/dialog'
Entity = require('views/templates/entity-react')
friendlyLinks = require 'views/internal/friendly-links'
log = require 'debug/log'
MemberAvatar = require 'views/member/member-avatar-react'
ModelCache = require 'db/model-cache'
{ PopulatingMinimalCanonicalCard } = require 'views/canonical-card/populating-canonical-card'
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactionPiles = require 'views/reactions/reaction-piles'
t = require('views/internal/recup-with-helpers')('notification')
Tooltip = require 'views/lib/tooltip'
l = require 'lib/localize'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
_ = require 'underscore'
$ = require 'jquery'

module.exports = class NotificationView extends React.Component
  el: null
  displayName: 'Notification'

  constructor: (props) ->
    super(props)

    @state = {
      isArchiveVisible: false
    }

  componentDidMount: ->
    @mounted = true

  componentWillUnmount: ->
    @mounted = false

  componentWillReceiveProps: (nextProps) ->
    if nextProps.archive != @props.archive
      # We will need to re-measure the archive after these props are applied
      @remeasure()

  componentDidUpdate: ->
    if @state.hasToRemeasure && @mounted
      @setState({
        archiveHeight: null
        hasToRemeasure: false
      }, =>
        if @mounted
          @setState({
            archiveHeight: $(@el).find('.archive').outerHeight()
          })
      )

  getIcon: (iconKey) ->
    iconKey = iconKey.replace('notification_', '')
    switch iconKey
      when 'added_attachment_to_card' then 'attachment'
      when 'added_a_due_date', 'changed_due_date', 'is_due', 'card_due_soon', 'is_due', 'was_due', 'removed_due_date' then 'clock'
      when 'added_to_card', 'added_to_organization', 'added_to_board' then 'add-member'
      when 'removed_from_board', 'removed_from_card', 'removed_from_organization' then 'remove-member.icon-custom'
      when 'archived_card', 'unarchived_card' then 'archive'
      when 'moved_card', 'created_card' then 'forward'
      when 'comment_card', 'mentioned_on_card' then 'comment'
      when 'made_admin_of_board', 'made_admin_of_organization' then 'member'
      when 'close_board' then 'close'
      when 'reopen_board' then 'refresh'
      else 'member'

  remeasure: =>
    @setState({
      hasToRemeasure: true
    })

  renderNotification: (notification, i) ->
    { type
    , isEnterpriseAdmin
    , date
    , entities
    , member
    , iconKey
    , actionLink
    , shouldGenerateActionLink
    , isSystemNotification
    , showReactions
    , canReact
    , actionId
    , reactionList
    } = notification

    t.div
      class: t.classify({
        'mod-system': isSystemNotification,
        'notification': true
        }),
      onClick: @clickedNotification.bind(props: notification), =>
        if member
          switch member.id
            when 'system' then break # NOOP
            when 'deleted account'
              t.div '.phenom-member', =>
                t.div '.phenom-creator', =>
                  t.div '.member', ->
                    t.span '.icon-lg.icon-member.member-avatar'
                t.div '.member-name', =>
                  t.format 'deleted-account'
            else
              t.div '.phenom-member.js-show-mem-menu.show-mem-menu', {
                'data-idmember': member.id,
                onClick: @viewMemberActionMenu.bind(@)
              }, =>
                t.div '.phenom-creator', =>
                  t.div '.member', ->
                    t.createElement MemberAvatar, member
                t.div '.member-name', =>
                  t.text member.fullName + '\xa0 '
                  if date && notification.isCommentLike
                    t.span '.member-date.quiet',
                      onClick: (e) -> e.stopPropagation()
                    , ->
                      t.span '.date', { 'data-date': date }
                return
        t.div '.content-wrapper', =>
          if shouldGenerateActionLink
            t.div '.phenom-icon.phenom-icon-link', =>
              t.a { href: actionLink }, =>
                t.span ".icon-sm.icon-#{@getIcon(iconKey)}"
          else
            t.div '.phenom-icon', =>
              t.span ".icon-sm.icon-#{@getIcon(iconKey)}"
          t.div
            class: t.classify({
              'phenom-desc': true
              'phenom-spacer': !isSystemNotification,
            }), =>
              if type == 'cardDueSoon'
                t.strong ->
                  t.format 'reminder'
              if shouldGenerateActionLink
                # calculate the number of rows and multiply by height of reaction pile (incl. margin)
                reactionItemHeight = $('.reaction-pile-item').outerHeight(true)
                reactionRowsHeight =
                  if reactionList?.length
                    (Math.ceil(reactionList.length / 6) * reactionItemHeight)
                  else
                    $('.reaction-piles-empty').outerHeight(true)
                t.span
                  style: { height: if reactionRowsHeight then "calc(100% - #{reactionRowsHeight}px)" else '100%' }
                  class: 'phenom-desc-link', ->
                    t.a { href: actionLink }
              _.forEach(entities, (entity) -> t.createElement Entity, { entity, context: {}, options: { isEnterpriseAdmin } })
              if showReactions && reactionList?
                t.div '.phenom-reactions', =>
                  t.createElement ReactionPiles, {
                    actionId,
                    reactionList,
                    canReact,
                    onReactionChanged: @remeasure
                    trackingContext: {
                      category: 'header'
                      actionId
                    }
                  }
              if date && !notification.isCommentLike
                t.span '.phenom-date.quiet', ->
                  t.text '\xa0 '
                  t.span '.date', { 'data-date': date }

  render: t.renderable ->
    { board
    , card
    , list
    , isCommentLike
    , isAddAttachment
    , unread
    , isSystemNotification
    , showArchiveButton
    , archive
    , active
    } = @props

    {
      archiveHeight
      isArchiveVisible
    } = @state

    t.div
      class: t.classify({
        'mod-comment-type': isCommentLike,
        'mod-attachment-type': isAddAttachment,
        'mod-unread': unread,
        'mod-system': isSystemNotification,
        'mod-is-card': card?
        'mod-is-not-card': !card?
        'archive-visible': isArchiveVisible
        'phenom': true
        }),
      ref: (el) =>
        @el = el
        Dates.update(el)
        _.each el?.querySelectorAll('.js-friendly-links'), (el) ->
          friendlyLinks el
    , =>
      t.div '.notification-views-actions', =>
        t.div
          onMouseEnter: @showTooltip
          onMouseLeave: @hideTooltip
          onClick: (e) =>
            @hideTooltip()
            @clickedNotification(e)
          class: t.classify({
            'js-toggle-read': true,
            'mark-read': unread,
            'mark-unread': !unread
          })
          'aria-label': l(['notification', if unread
            'mark read'
          else
            'mark unread'])

        if card?
          t.div
            class: 'card-actions'
            onClick: (e) =>
              @openActionsPopver(e)
              @trackWithData(
                'opens'
                'actions menu'
                ''
                'on notifications menu'
                'by clicking the actions menu button on notifications'
              )
            , ->
              t.icon 'overflow-menu-horizontal'

      t.div '.unread-cover'
      if card? && board?
        t.tag PopulatingMinimalCanonicalCard, {
          isPolling: true
          cardName: card.name
          cardUrl: if card.shortLink? then "/c/#{card.shortLink}"
          boardName: board.name
          boardUrl: if board.shortLink? then "/b/#{board.shortLink}"
          idBoard: board.id
          idCard: card.id
          listName: list?.name
          isWide: true
        }

      if showArchiveButton
        t.button '.archive-button.quiet.unstyled-button',
          onClick: @toggleArchive.bind(@, false), =>
            t.icon 'down'
            if isArchiveVisible
              t.format 'hide-previous-card-activity'
            else
              t.format 'show-previous-card-activity'

      if archive? && archive.length > 0
        t.div
          style: { height: if isArchiveVisible && archiveHeight != 0 then archiveHeight }
          class: t.classify({
            'measuring': !archiveHeight?
            'measuring-closed': !archiveHeight? && !isArchiveVisible
            'archive': true
          }), =>
            archive.forEach(@renderNotification.bind(@))

            t.button '.archive-button.quiet.unstyled-button',
              onClick: @toggleArchive.bind(@, true), =>
                t.icon 'down'
                t.format 'hide'

      active?.forEach(@renderNotification.bind(@))

    log('notifications', @props)

  showTooltip: (e) ->
    $btn = @$(e.target)
    Tooltip.show($btn.attr('aria-label'), $btn, false, Tooltip.STYLE.MENU)

  trackWithData: (verb, dirObj, prepObj, indObj, method) ->
    { card, list, board } = @props

    context = JSON.stringify
      cardId: card?.id
      listId: list?.id
      boardId: board?.id

    trackUe('header', verb, dirObj, prepObj, indObj, method, context)

  hideTooltip: ->
    Tooltip.hide()

  toggleArchive: (shouldMaintainScroll = false) =>
    { isArchiveVisible, archiveHeight } = @state

    if !archiveHeight?
      @setState
        archiveHeight: $(@el).find('.archive').outerHeight()

      # We have to wait for the render to update before we toggle the visibility
      # otherwise the height won't have time to reset for the animation
      setTimeout(
        => if @mounted
          @setState isArchiveVisible: !isArchiveVisible,
        100
      )
    else
      @setState isArchiveVisible: !isArchiveVisible

    @trackWithData(
      if isArchiveVisible then 'closes' else 'opens'
      'archive'
      'on notifications menu'
      ''
      if isArchiveVisible && shouldMaintainScroll
        "by clicking hide button"
      else
        "by clicking #{if isArchiveVisible then 'hide' else 'show'} previous card activity button"
    )

    if(isArchiveVisible && archiveHeight? && shouldMaintainScroll)
      # Maintain the position of scroll.
      # 500ms is the speed in the css animation too.
      # So change both if changing this one
      scrollList = $('.notification-list-holder')
      scrollList.animate({
        scrollTop: scrollList.scrollTop() - archiveHeight
      }, 500)

  trackCardClick: (e) =>
    clickedLink = e.target.closest('a')
    # Opens board or card
    if clickedLink?
      # If is contains /c/ it's the card
      if /\/c\//.test(clickedLink.getAttribute 'href')
        dirObj = 'card detail'
      else
        dirObj = 'board'

      @trackWithData(
        'opens'
        dirObj
        'on notifications menu'
        ''
        'by clicking on a notification in notifications menu'
      )

  clickedNotification: (e) ->
    if @props.context == 'header'
      track("Header", "Notifications Menu", "Clicked Notification")
    else if @props.context == 'notifications-page'
      track("Member View", "Notifications Page", "Clicked Notification")

    if $(e.target).is('.js-toggle-read')
      @props.toggleRead()
    else if !$(e.target).is('a')
      Util.stop(e)
    else if !(e.metaKey || e.ctrlKey)
      Dialog.hide() # Will no-op in when we're not in a dialog.

  viewMemberActionMenu: (e) ->
    Util.stop(e)

    member = ModelCache.get('Member', $(e.target).closest('[data-idmember]').attr("data-idmember") ? @props.idMemberCreator)

    if $(e.target).closest('.pop-over').length > 0
      PopOver.pushView
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    else
      PopOver.toggle
        elem: $(e.target).closest('.js-show-mem-menu')
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    return

  openActionsPopver: (e) =>
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('.card-actions')
      getViewTitle: -> l ['view title', 'card actions']
      reactElement: React.createElement CardActionsPopover,
        key: 'actions-popover',
        idCard: @props.card?.id
        idList: @props.list?.id
        idBoard: @props.board?.id



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-view.coffee